var map = {
	"./CopyrightKJHZ.svg": 3092,
	"./KJDBellebenCopyright.svg": 7987,
	"./KJHZ_DashboardLogo.svg": 7939,
	"./administration-logo-demo.svg": 6996,
	"./administration-logo-kijuhome.svg": 1691,
	"./emper_tools_gmbh_copyright.svg": 1628,
	"./fuchsbau_logo_login.svg": 7595,
	"./garsena_logo.svg": 9831,
	"./garsena_logo_login.svg": 7425,
	"./kjd-belleben-logo.svg": 3005,
	"./tagebuch-logo-demo.svg": 8905,
	"./tagebuch-logo-fuchsbau.svg": 1475,
	"./tagebuch-logo-garsena.svg": 5801,
	"./tagebuch-logo-kijuhome.svg": 7402,
	"./tagebuch-logo-kjd-belleben.svg": 3053,
	"./tagebuch-logo-kjhz.svg": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4336;